type requestObj = {
  id: string;
  quantity: string;
};

const changeCart = async (requestObj: requestObj) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestObj),
  });
};

export { changeCart };
